import type { AwsConfigurationOptions } from "~/operations";

// When useWif is false, the backend returns a URL ending with `&param_MondooToken=`
// so the registration token is appended verbatim — no key, no separator.
export function awsQuickcreateUrl(
  configurationOptions: Pick<
    AwsConfigurationOptions,
    "cloudFormationQuickcreateUrl" | "useWif"
  >,
  token?: string | null,
): string {
  const url = configurationOptions.cloudFormationQuickcreateUrl;
  return configurationOptions.useWif ? url : url + (token ?? "");
}
